import React from 'react';

import { CookieConsentProvider } from './CookieConsentProvider';

import CookieConsentModal from './CookieConsentModal';

/**
 * For legacy reasons a provider wrapping the modal directly is exported.
 *
 * In the long run, this should not be used anymore. The context provider and
 * modal should be used separately instead.
 *
 * @param props
 * @returns {JSX.Element}
 * @deprecated
 */
export const CookieConsentProviderWithModal = (props) => (
  <CookieConsentProvider>
    <CookieConsentModal {...props} />
  </CookieConsentProvider>
);

CookieConsentProviderWithModal.propTypes = CookieConsentModal.propTypes;
